import { render } from "./GiftRewardAdminPanel.vue?vue&type=template&id=c06914c6&scoped=true"
import script from "./GiftRewardAdminPanel.vue?vue&type=script&lang=js"
export * from "./GiftRewardAdminPanel.vue?vue&type=script&lang=js"

import "./GiftRewardAdminPanel.vue?vue&type=style&index=0&id=c06914c6&scoped=true&lang=css"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c06914c6"]])

export default __exports__